import React from "react";
import { Button, Group, Text } from "@mantine/core";

interface ReferralTablePaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

/**
 * Component for displaying table pagination controls
 */
export const ReferralTablePagination: React.FC<
  ReferralTablePaginationProps
> = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  return (
    <Group justify="center" mt="md">
      <Button
        variant="light"
        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1}
      >
        Previous
      </Button>
      <Text size="sm" c="dimmed">
        Page {currentPage} of {totalPages}
      </Text>
      <Button
        variant="light"
        onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage >= totalPages}
      >
        Next
      </Button>
    </Group>
  );
};
